var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRollFoil = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.22 23.71",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68 15.33s-.03 2 2.04 2.44c0 0 1.39.19 2.24-.67 0 0 1.06-.83.9-2.4 0 0-.07-1.95-2.16-2.71 0 0-.9-.43-2.16-.2-1.17.22-2.2.96-2.8 1.99-.36.61-.63 1.41-.54 2.38 0 0-.02.83.57 1.87.44.77 1.13 1.38 1.91 1.81 1.04.57 2 .7 3.45.41 0 0 2.74-.43 3.89-2.83 0 0 1.3-2.29-.28-4.96 0 0-1.26-2.54-4.13-3.06 0 0-.17-.05-.47-.09-2.5-.37-5.06.72-6.44 2.84-.01.02-.03.05-.04.07-.26.41-.43.86-.56 1.33-.25.92-.52 2.48-.07 4.1 0 0 .35 1.93 1.81 3.14 0 0 .59.68 1.95 1.38.71.36 1.48.6 2.27.7.26.03.52.05.73.04h17.52l11.98-11.87-17.54-.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.39 11.26 9.37-9.43s2.2-1.48 4.76-.9c0 0 2.27.37 3.51 2.23 0 0 1.05 1.47 1.04 3.42 0 0 .26 2.64-2.07 4.75l-7.19 7.62"
  }))));
};
export default SvgIconRollFoil;